var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageAlertSquare = function SvgMessageAlertSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.875v-7.292m0 14.584h.02M14.584 37.5v4.866c0 1.11 0 1.665.228 1.95.198.248.498.392.815.392.365 0 .798-.347 1.665-1.04l4.97-3.977c1.015-.812 1.523-1.218 2.088-1.507a6.25 6.25 0 0 1 1.587-.556c.622-.128 1.272-.128 2.572-.128h5.242c3.5 0 5.25 0 6.587-.681a6.25 6.25 0 0 0 2.732-2.732c.681-1.337.681-3.087.681-6.587V16.25c0-3.5 0-5.25-.681-6.587a6.25 6.25 0 0 0-2.732-2.732C39 6.25 37.25 6.25 33.75 6.25h-17.5c-3.5 0-5.25 0-6.587.681A6.25 6.25 0 0 0 6.93 9.663c-.681 1.336-.681 3.087-.681 6.587v12.917c0 1.937 0 2.906.213 3.7a6.25 6.25 0 0 0 4.42 4.42c.794.213 1.763.213 3.7.213Z",
    stroke: "#4A49BB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMessageAlertSquare;